const installGoogleAnalytics = (env = {}) => {
  if (!env.GA_MEASUREMENT_ID) { return }

  if (!window.gtag) {
    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
  }

  // push the config event for the GA ID
  window.gtag('config', env.GA_MEASUREMENT_ID, { send_page_view: false })

  // and insert the script tag
  const el = document.createElement('script')
  el.async = true
  el.src = 'https://www.googletagmanager.com/gtag/js?id=' + env.GA_MEASUREMENT_ID
  const script1 = document.getElementsByTagName('script')[0]
  script1.parentNode.insertBefore(el, script1)
}

export const start = ({ env, routes }) => {
  window.__maui_mf_env__ || (window.__maui_mf_env__ = env)

  installGoogleAnalytics(env)

  import('./bootstrap.js').then(bootstrap => {
    bootstrap.start({ routes })
  })
}
